
  @for(item of options().options; track item; let i = $index) {
    <div class="form-check form-check-inline">
      <input
        #radio
        class="form-check-input"
        type="radio"
        name="inlineRadioOptions"
        [checked]="options().value === item.value"
        [formControl]="options().formControl!"
        [id]="'radio' + $index"
        [value]="item.label"
        (input)="onInput(item.value)"
      >
      <label class="form-label form-check-label" [for]="'radio' + $index">{{translations[item.label]}}</label>
    </div>
  }
